export default "__VITE_ASSET__FSdCsqC6__"